<template>
    <div>
        {{ emailables.length }} emails
        <div class="pull-right">
            <report-settings></report-settings>
            &nbsp;
            <a class="button is-primary pull-right" :href="'/api/reports/emails?company='+reportCompany">Download in Excel</a>
        </div>
        <div class="is-clearfix"></div>
        <div class="container">
            <data-table :data-set="emailables" :page-length="50" :columns="[
            {name: 'Contact', prop: ['first_name', 'last_name'], type: 'text'},
            {name: 'Email', prop: 'email', type: 'text'},
            {name: 'Source', prop: 'source', type: 'text'},
        ]"></data-table>
        </div>
    </div>
</template>

<script>
    import * as reportsAPI from "../../store/api/reports"
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {
                emailables: []
            }
        },
        mounted() {
            this.getEmailList()
        },
        computed: mapGetters(['products', 'reportCompany']),
        methods: {
            getEmailList() {
                reportsAPI.getEmailList(this.$store.commit, {company: this.reportCompany})
                    .then(data => {
                        this.emailables = data
                    })
            },
        },
        watch: {
            'reportCompany': 'getEmailList'
        }
    };
</script>



// WEBPACK FOOTER //
// EmailList.vue?393839e2